
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forms-and-documents",
      function () {
        return require("private-next-pages/forms-and-documents.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forms-and-documents"])
      });
    }
  